import type { MatrixClient } from 'matrix-js-sdk'

export interface SpaceInfo {
  roomId: string
  name: string
  avatarUrl: string | null
  /** Direct child room ids declared via m.space.child state. */
  childIds: string[]
}

export interface SpacesResult {
  spaces: SpaceInfo[]
  /** All space room ids — these are containers, not chats, so they're hidden from the room list. */
  spaceIds: Set<string>
}

// Derive the Space hierarchy from the client's room state. m.space.child state
// events on a Space room name its children (state key = child room id); empty
// content means the child was removed.
export function getSpaces(client: MatrixClient): SpacesResult {
  const spaces: SpaceInfo[] = []
  const spaceIds = new Set<string>()

  for (const room of client.getRooms()) {
    if (!room.isSpaceRoom() || room.getMyMembership() !== 'join') continue
    spaceIds.add(room.roomId)

    const childIds = room.currentState
      .getStateEvents('m.space.child')
      .filter((e) => Object.keys(e.getContent() ?? {}).length > 0)
      .map((e) => e.getStateKey())
      .filter((k): k is string => !!k)

    spaces.push({
      roomId: room.roomId,
      name: room.name || room.roomId,
      avatarUrl: room.getMxcAvatarUrl() ?? null,
      childIds,
    })
  }

  spaces.sort((a, b) => a.name.localeCompare(b.name))
  return { spaces, spaceIds }
}
